import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { CommunityBankService } from '@app/core/http';
import { untilDestroyed } from '@ngneat/until-destroy';
import { finalize } from 'rxjs/operators';

@Component({
  selector: 'app-select-bank',
  templateUrl: './select-bank.component.html',
})
export class SelectBankComponent implements OnInit, OnDestroy {
  constructor(
    private communityBankService: CommunityBankService,
    private router: Router
  ) {}

  isLoading = true;
  selectedBank = {
    swiftCode: '',
    bankName: '',
  };
  cancelRedirectUrl = null;
  banks = null;
  defaultPaymentMethod = JSON.parse(localStorage.getItem('transaction'))[
    'defaultPaymentMethod'
  ];

  ngOnInit() {
    this.cancelRedirectUrl = localStorage.getItem('cancelRedirectUrl') || null;
    this.communityBankService
      .getBanks()
      .pipe(finalize(() => (this.isLoading = false)))
      .pipe(untilDestroyed(this))
      .subscribe((banks) => {
        if (
          this.defaultPaymentMethod === 'PAPARAC' ||
          this.defaultPaymentMethod === 'PEPPARAC'
        ) {
          const swiftCode =
            this.defaultPaymentMethod === 'PAPARAC'
              ? 'PAPARA'
              : this.defaultPaymentMethod === 'PEPPARAC'
              ? 'PEPPARA'
              : '';
          this.router.navigate([`/community-banks/${swiftCode.toLowerCase()}`]);
        } else {
          this.banks = banks;
        }
      });
  }

  backToMerchant() {
    localStorage.clear();
    window.location.href = this.cancelRedirectUrl;
  }

  onSubmit() {
    this.router.navigate([
      `/community-banks/${this.selectedBank.swiftCode.toLowerCase()}`,
    ]);
  }

  ngOnDestroy() {}
}
